<template>
  <InputComponent v-bind="$attrs" class="field-select">
    <template #default>
      <select
        class="field-select__element"
        :class="{ 'field-select__element--placeholder': isUnselected }"
        v-bind="$attrs"
        :value="value"
        @input="$ev => $emit('input', $ev.target.value)"
      >
        <option v-if="placeholder" :value="undefined" disabled dir="ltr">{{ placeholder }}</option>
        <option v-for="(item, index) in items" :key="index" :value="item.id || item.value">
          {{ item.title || item.label }}
        </option>
      </select>
      <FontAwesomeIcon class="field-select__icon" :icon="['fal', 'angle-down']" size="lg" />
    </template>
  </InputComponent>
</template>

<script>
import { InputComponent } from 'vue-elder-input'

export default {
  props: {
    value: [String, Array],
    placeholder: {
      type: String,
      default() {
        return this.$t('select') + '...'
      },
    },
    items: {
      type: Array,
      default: () => [],
    },
    default: String,
  },
  computed: {
    isUnselected() {
      return this.placeholder && this.value === undefined
    },
  },
  created() {
    if (this.default) this.$emit('input', this.default)
  },
  components: {
    InputComponent,
  },
}
</script>

<style lang="scss">
.field-select {
  position: relative;
  width: 100%;
  flex-grow: 0 !important;

  &__element {
    appearance: none;
    width: 100%;
    height: 100%;
    padding: 1.1rem 2.5rem 1.1rem 1.1rem;
    border-radius: var(--border-radius);

    &--placeholder {
      opacity: 0.3;
    }

    &:focus-visible {
      outline: 1px solid var(--primary);
    }
  }

  &__icon {
    position: absolute;
    right: 1.1rem;
    top: 50%;
    transform: translateY(-45%);
    color: inherit;
    opacity: 0.5;
    pointer-events: none;
  }
}
</style>
